/* ===========================================================================
   RECENT ENTRIES
   The rail is a native scroll container, so swipe works on touch without any
   of this. The arrows drive the same scroll and grey out at the ends.
   =========================================================================== */
(function () {
  function init(root) {
    if (!root || root.dataset.fcdInit === '1') return;
    root.dataset.fcdInit = '1';

    var track = root.querySelector('[data-fcd-track]');
    var prev = root.querySelector('[data-fcd-prev]');
    var next = root.querySelector('[data-fcd-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.fc-dcard');
      if (!card) return track.clientWidth;
      var s = getComputedStyle(track);
      var gap = parseFloat(s.columnGap || s.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      var none = max <= 2;
      prev.disabled = none || track.scrollLeft <= 2;
      next.disabled = none || track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  }

  function boot() { document.querySelectorAll('.fc-drecent').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

/* ===========================================================================
   DIARY HERO
   A transform slider rather than a scroll container, because the card hangs
   past the right edge of its slide: in a scroll container that overhang adds
   to the scrollable width and the last slide can never be reached.
   =========================================================================== */
(function () {
  function init(root) {
    if (!root || root.dataset.fcdhInit === '1') return;
    root.dataset.fcdhInit = '1';

    var track = root.querySelector('[data-fcdh-track]');
    if (!track) return;
    var real = Array.prototype.slice.call(track.children);
    if (real.length < 2) return;

    var prev = root.querySelector('[data-fcdh-prev]');
    var next = root.querySelector('[data-fcdh-next]');

    /* A true loop needs somewhere to go past each end. Copy the last slide in
       front of the first and the first after the last, sit on the real first,
       and when a move lands on a copy, jump to its twin with the transition
       off. The eye never sees the jump because both frames are identical. */
    var head = real[real.length - 1].cloneNode(true);
    var tail = real[0].cloneNode(true);
    [head, tail].forEach(function (c) {
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
    });
    track.insertBefore(head, real[0]);
    track.appendChild(tail);

    var slides = Array.prototype.slice.call(track.children);
    var count = real.length;
    var index = 1;
    var startX = 0, dx = 0, dragging = false;

    function width() { return slides[0].getBoundingClientRect().width; }

    function place(animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + (-index * width()) + 'px)';
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
    }

    function apply() { place(true); }

    /* Landing on a copy, step across to its twin with the transition off. The
       eye cannot see the swap because the two frames are identical.

       Driven off a timer rather than transitionend: the event fires reliably
       enough, but a second move started before the first finished left the
       handler resetting against an index that had already moved on, and the
       slider walked off the end. One timer, cancelled on every move, cannot. */
    var SLIDE_MS = 550;
    var settle = null;

    function normalise() {
      if (index === 0) { index = count; place(false); }
      else if (index === count + 1) { index = 1; place(false); }
    }

    function go(n) {
      index = n;
      place(true);
      clearTimeout(settle);
      settle = setTimeout(normalise, SLIDE_MS + 40);
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    window.addEventListener('resize', function () { place(false); });

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; startX = e.clientX; dx = 0;
      track.style.transition = 'none';
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      track.style.transform = 'translateX(' + (-index * width() + dx) + 'px)';
    });

    function release() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var threshold = width() * 0.15;
      if (dx < -threshold) { go(index + 1); }
      else if (dx > threshold) { go(index - 1); }
      else { apply(); }
    }

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      track.addEventListener(ev, release);
    });

    // a drag that ends on a link should not follow it
    track.addEventListener('click', function (e) {
      if (Math.abs(dx) > 8) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    place(false);
  }

  function boot() { document.querySelectorAll('.fc-dhero').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
